module.exports = __webpack_public_path__ + "img/55_27.da88f5ae.png";